export const MASK = new Array(9).fill(/\d/);
